export const PLATFORMS = [
  { value: 'instagram', label: 'Instagram', isPublic: false },
  { value: 'x',         label: 'X (Twitter)', isPublic: false },
  { value: 'facebook',  label: 'Facebook',  isPublic: false },
  { value: 'telegram',  label: 'Telegram',  isPublic: false },
  { value: 'linkedin',  label: 'LinkedIn',  isPublic: false },
  { value: 'signal',    label: 'Signal',    isPublic: false },
  { value: 'github',    label: 'GitHub',    isPublic: true },
  { value: 'bluesky',   label: 'Bluesky',   isPublic: true },
  { value: 'farcaster', label: 'Farcaster', isPublic: true },
  { value: 'nostr',     label: 'Nostr',     isPublic: true },
  { value: 'bitchat',   label: 'BitChat',   isPublic: true },
];
